import { mainLocator as locator } from "@core/di/main.locator";
import { StorageService } from "@core/services/storage-service";
import { LoginStore } from "@modules/authentication/pages/login/login.store";
import LoaderService from "@shared/components/loader/loader.service";

locator.registerInstance(
  "LoginStore",
  new LoginStore(
    locator.resolve<LoaderService>("LoaderService"),
    locator.resolve<StorageService>("StorageService"),
  ),
);
